module.exports = __webpack_public_path__ + "static/media/blackHeartIcon.9488c27d.svg";